import {Popover} from '../../../popover/popover';
import {Body} from '../../../typography/body';
import {useRefObserver} from '../../../utils/hooks/use-ref-observer';

interface Props {
    anchorRef: React.MutableRefObject<HTMLDivElement | null | undefined>;
    isOverLimit: boolean;
    characterLimit: number;
}

export function CharacterLimitPopover(props: Props) {
    const {isHovered} = useRefObserver(props.anchorRef, ['isHovered']);

    if (!isHovered || !props.isOverLimit) return null;

    return (
        <Popover
            anchor={props.anchorRef.current}
            location='top'
            bodyColor='dark'
            isNubDark={true}
            zIndex={10000}
        >
            <div className='pad-8'>
                <Body color='white' size='small'>
                    Outgoing messages have a {props.characterLimit} character limit.
                </Body>
            </div>
        </Popover>
    );
}
